// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'


import vuetify from '@/plugins/vuetify' // path to vuetify export

import _ from 'lodash'

import __ from 'lodash-contrib';

import VueResource from 'vue-resource';
import VueRouter from 'vue-router'

import VuePageTitle from 'vue-page-title'

import 'bootstrap';

import * as VueGoogleMaps from 'vue2-google-maps'



import VueGeolocation from 'vue-browser-geolocation';

import VueGmaps from 'vue-gmaps';

Vue.use(VueGeolocation);
Vue.use(VueResource);

Vue.use(VuePageTitle, {
  // prefix: 'My App - ',
  suffix: 'OJEY LIVRAISON'
})

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyACue3HyWbVZ7KJQmjILIvNZed8-KPh36k',
    libraries: 'places',
    installComponents: true
   },
});
Vue.use(VueGmaps, {
  key: 'AIzaSyACue3HyWbVZ7KJQmjILIvNZed8-KPh36k',
  libraries: ['places'],
  version: '3'
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  vuetify,
  router,
  http:{
    emulateJSON: true,
    emulateHTTP: true
  },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js